import React from 'react';
import { Button } from '../components/Button';
import { Link } from 'react-router-dom';
import { SEO } from '../components/SEO';
export function ForManufacturers() {
  return <>
      <SEO title="Aspect for Manufacturers" description="Request access to verified, rights-cleared imagery of real-world architectural installations." data-id="element-210" />
      <div className="space-y-24 md:space-y-32" data-id="element-211">
        <section className="max-w-2xl" data-id="element-212">
          <span className="text-aspect-gray block mb-4" data-id="element-213">For Manufacturers</span>
          <h1 className="text-3xl md:text-4xl font-medium leading-tight mb-8 text-aspect-black" data-id="element-214">
            Access to rights-cleared, verified imagery of real-world
            installations, structured for enterprise use.
          </h1>
          <div className="mt-10" data-id="element-215">
            <Link to="/manufacturers/request" data-id="element-216">
              <Button variant="primary" icon data-id="element-217">
                Request access
              </Button>
            </Link>
          </div>
        </section>

        {/* Today vs Later */}
        <section className="grid md:grid-cols-12 gap-8 md:gap-12 border-t border-aspect-gray/20 pt-12" data-id="element-218">
          <div className="md:col-span-4" data-id="element-219">
            <span className="text-aspect-gray" data-id="element-220">Roadmap</span>
          </div>
          <div className="md:col-span-8 space-y-8" data-id="element-221">
            <h2 className="text-2xl font-medium" data-id="element-222">What Exists Today vs Later</h2>

            <div className="grid md:grid-cols-2 gap-8" data-id="element-223">
              <div className="space-y-4" data-id="element-224">
                <h3 className="text-lg border-b border-aspect-gray/20 pb-2" data-id="element-225">
                  Today
                </h3>
                <ul className="space-y-2 text-aspect-black/80" data-id="element-226">
                  <li data-id="element-227">Defined workflows</li>
                  <li data-id="element-228">Rights and verification standards</li>
                  <li data-id="element-229">Early inventory under controlled release</li>
                </ul>
              </div>

              <div className="space-y-4" data-id="element-230">
                <h3 className="text-lg border-b border-aspect-gray/20 pb-2 text-aspect-gray" data-id="element-231">
                  Later
                </h3>
                <ul className="space-y-2 text-aspect-gray" data-id="element-232">
                  <li data-id="element-233">Expanded library</li>
                  <li data-id="element-234">Alerts and structured discovery</li>
                  <li data-id="element-235">Deeper integrations</li>
                </ul>
              </div>
            </div>

            <p className="text-sm text-aspect-gray pt-4" data-id="element-236">
              Future capabilities are introduced only when operational.
            </p>
          </div>
        </section>

        {/* Licensing Model */}
        <section className="grid md:grid-cols-12 gap-8 md:gap-12 border-t border-aspect-gray/20 pt-12" data-id="element-237">
          <div className="md:col-span-4" data-id="element-238">
            <span className="text-aspect-gray" data-id="element-239">Licensing</span>
          </div>
          <div className="md:col-span-8 space-y-8" data-id="element-240">
            <h2 className="text-2xl font-medium" data-id="element-241">
              Licensing Model (High Level)
            </h2>
            <div className="space-y-4 text-aspect-black/80 leading-relaxed max-w-xl" data-id="element-242">
              <p data-id="element-243">Licensing is explicit, documented, and auditable.</p>
              <p data-id="element-244">Usage terms are known before download.</p>
            </div>
          </div>
        </section>

        {/* Guarantees */}
        <section className="grid md:grid-cols-12 gap-8 md:gap-12 border-t border-aspect-gray/20 pt-12" data-id="element-245">
          <div className="md:col-span-4" data-id="element-246">
            <span className="text-aspect-gray" data-id="element-247">Guarantees</span>
          </div>
          <div className="md:col-span-8 space-y-8" data-id="element-248">
            <h2 className="text-2xl font-medium" data-id="element-249">Guarantees That Apply</h2>
            <ul className="space-y-4 text-aspect-black/80 max-w-xl" data-id="element-250">
              <li data-id="element-251">No ambiguous rights</li>
              <li data-id="element-252">No unverifiable products</li>
              <li data-id="element-253">No undocumented reuse</li>
            </ul>
          </div>
        </section>

        {/* Access */}
        <section className="grid md:grid-cols-12 gap-8 md:gap-12 border-t border-aspect-gray/20 pt-12 pb-12" data-id="element-254">
          <div className="md:col-span-4" data-id="element-255">
            <span className="text-aspect-gray" data-id="element-256">Access</span>
          </div>
          <div className="md:col-span-8 space-y-8" data-id="element-257">
            <h2 className="text-2xl font-medium" data-id="element-258">Requesting Access</h2>
            <div className="space-y-6 text-aspect-black/80 leading-relaxed max-w-xl" data-id="element-259">
              <p data-id="element-260">Manufacturer access is reviewed.</p>
              <p data-id="element-261">Aspect is not self-serve.</p>
              <div className="pt-4" data-id="element-262">
                <Link to="/manufacturers/request" data-id="element-263">
                  <Button variant="primary" icon data-id="element-264">
                    Request access
                  </Button>
                </Link>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>;
}